import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { product } from '../../data/product';
export function HeroSection() {
  const reduce = useReducedMotion();
  const ease = [0.23, 1, 0.32, 1] as const;
  return <section id="inicio" aria-labelledby="hero-titulo" className="w-full bg-ivory" data-id="element-95" data-mp="12ly48w8qdl17">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 pb-20 pt-6 lg:grid-cols-12 lg:items-center lg:gap-12 lg:px-10 lg:pb-32 lg:pt-12" data-id="element-96" data-mp="12jv6fq1c6nlx">
        <motion.div className="lg:col-span-6" initial={reduce ? false : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-97" data-mp="1ucm0btvjs080">
          <h1 id="hero-titulo" className="font-serif text-[2.4rem] font-normal leading-[1.08] tracking-tight text-carbon sm:text-5xl lg:text-[3.6rem]" data-id="element-98" data-mp="1lbe6pp3z7nk9">
            ¿Cuántas cosas has dejado de hacer por miedo a{' '}
            <em className="italic text-gold-ink" data-id="element-99" data-mp="9zn41mp1dm4x">lo que otros piensen?</em>
          </h1>
          <div className="mt-8 max-w-md space-y-2 text-lg leading-relaxed" data-id="element-100" data-mp="38e8fn9pz9wkw">
            <p className="text-stone" data-id="element-101" data-mp="3dew8m0xronhr">A veces no nos faltan sueños, talento ni oportunidades.</p>
            <p className="font-medium text-carbon" data-id="element-102" data-mp="2zf4xc7ymxl7g">Nos falta atrevernos a comenzar.</p>
          </div>
          <a href="#libro" className="mt-10 hidden items-center gap-2 text-sm font-medium text-carbon transition-colors duration-150 ease-out hover:text-gold-ink lg:inline-flex" data-id="element-103" data-mp="34d6hkw7srqki">
            Conoce el libro
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="2gp5alrq9oi77" />
          </a>
        </motion.div>

        <motion.figure className="lg:col-span-6" initial={reduce ? false : {
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease,
        delay: reduce ? 0 : 0.06
      }} data-id="element-105" data-mp="2kqh5ocrwtvms">
          <img src={product.mockupImage} alt={`Ebook «${product.title} — ${product.titleTail}» de ${product.author}`} className="aspect-[4/5] w-full rounded-sm object-cover object-right" data-id="element-106" data-mp="2bpj2fwpaps59" />
          <figcaption className="mt-4 flex items-center justify-between gap-4 text-sm text-stone" data-id="element-107" data-mp="8hjqohnf8xrd">
            <span className="font-serif italic" data-id="element-108" data-mp="3ifj1vg5b835">
              {product.title} — {product.titleTail}
            </span>
            <span className="shrink-0" data-id="element-109" data-mp="1097ycqv98w3v">{product.author}</span>
          </figcaption>
        </motion.figure>

        <a href="#libro" className="inline-flex items-center gap-2 text-sm font-medium text-carbon lg:hidden" data-id="element-110" data-mp="w6uts5s8v48o">
          Conoce el libro
          <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="m8x89q1rrljr" />
        </a>
      </div>
    </section>;
}